export const CORPORATE_COMPANY = {
  shortName: "魔法向量",
  fullName: "上海魔法向量人工智能技术有限公司",
  slogan: "用人工智能科技，助力传统行业数字化升级",
  intro:
    "上海魔法向量人工智能技术有限公司专注于将大模型、计算机视觉与行业知识图谱落地到制造、零售、金融、能源等传统产业场景，提供从咨询规划、算法研发到系统集成与持续运维的一站式服务。",
  email: "contact@magicvector.cn",
  founded: "2026",
  employees: "120+",
  clients: "80+",
  projects: "200+",
};

export type CorporateNavItem = {
  key: string;
  label: string;
  path: string;
};

export const CORPORATE_NAV: CorporateNavItem[] = [
  { key: "home", label: "首页", path: "/" },
  { key: "about", label: "关于我们", path: "/about" },
  { key: "solutions", label: "解决方案", path: "/solutions" },
  { key: "cases", label: "成功案例", path: "/cases" },
  { key: "news", label: "新闻动态", path: "/news" },
  { key: "contact", label: "联系我们", path: "/contact" },
];

export type CorporateSolution = {
  id: string;
  title: string;
  summary: string;
  highlights: string[];
  industries: string[];
};

export const CORPORATE_SOLUTIONS: CorporateSolution[] = [
  {
    id: "smart-factory",
    title: "智能制造助手",
    summary: "面向离散制造与流程工业，构建设备预测性维护、质量视觉检测与生产排程优化能力。",
    highlights: ["设备故障提前 7 天预警", "质检漏检率下降 62%", "产线 OEE 提升 11%"],
    industries: ["装备制造", "汽车零部件", "电子组装"],
  },
  {
    id: "retail-brain",
    title: "智慧零售大脑",
    summary: "打通会员、库存与营销数据，提供智能选品、动态定价与门店客流分析。",
    highlights: ["坪效提升 18%", "滞销 SKU 识别自动化", "会员复购率提升 24%"],
    industries: ["连锁商超", "便利店", "品牌专卖"],
  },
  {
    id: "finance-copilot",
    title: "金融风控 Copilot",
    summary: "结合 NLP 与知识图谱，辅助信贷审批、反欺诈监测与合规文档审查。",
    highlights: ["审批效率提升 3 倍", "欺诈识别召回率 96%", "合规审查人力节省 40%"],
    industries: ["商业银行", "消费金融", "保险"],
  },
  {
    id: "energy-insight",
    title: "能源智慧运维",
    summary: "针对电力、石化与新能源场站，实现能耗诊断、巡检机器人调度与碳排核算。",
    highlights: ["单位能耗下降 9%", "巡检人力节省 55%", "碳排报告自动生成"],
    industries: ["电力", "石化", "新能源"],
  },
];

export type CorporateCase = {
  id: string;
  client: string;
  industry: string;
  title: string;
  result: string;
  detail: string;
};

export const CORPORATE_CASES: CorporateCase[] = [
  {
    id: "case-1",
    client: "华东某精密制造企业",
    industry: "装备制造",
    title: "产线视觉质检与预测性维护一体化",
    result: "年节省质检人力 320 万，非计划停机下降 47%",
    detail:
      "部署 86 路工业相机与边缘推理节点，对接 MES 与 ERP，实现缺陷自动分级与维修工单联动。",
  },
  {
    id: "case-2",
    client: "全国连锁生鲜品牌",
    industry: "零售",
    title: "门店智能补货与损耗预测",
    result: "生鲜损耗率从 8.2% 降至 5.1%",
    detail:
      "基于历史销售、天气与促销数据训练需求预测模型，自动生成门店补货建议并推送至供应链系统。",
  },
  {
    id: "case-3",
    client: "某城商行零售信贷部",
    industry: "金融",
    title: "智能信审辅助与反欺诈引擎",
    result: "人均审批量提升 2.8 倍，不良率保持稳定",
    detail:
      "构建企业知识库与规则引擎，辅助客户经理完成材料核验与风险要点提示，可疑交易实时拦截。",
  },
  {
    id: "case-4",
    client: "西北某风电场群",
    industry: "新能源",
    title: "风机健康度评估与巡检路径优化",
    result: "单次巡检成本降低 38%",
    detail:
      "融合 SCADA 时序数据与无人机影像，输出风机健康评分与优先级巡检计划，减少无效出车。",
  },
];

export type CorporateNews = {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  content: string;
};

export const CORPORATE_NEWS: CorporateNews[] = [
  {
    id: "news-1",
    title: "魔法向量发布「TradAI 行业大模型套件」",
    date: "2026-07-28",
    category: "产品发布",
    summary: "面向制造、零售、金融三大场景推出可私有化部署的行业大模型套件。",
    content:
      "TradAI 套件包含行业语料清洗工具、RAG 知识库、微调训练流水线与运维监控面板，支持在客户内网完成全链路部署。首批合作伙伴包括两家装备制造集团与一家区域性商业银行。",
  },
  {
    id: "news-2",
    title: "公司与上海某高校共建「传统产业 AI 联合实验室」",
    date: "2026-06-15",
    category: "合作动态",
    summary: "聚焦工业视觉与小样本学习方向，联合培养应用型 AI 工程师。",
    content:
      "联合实验室将开放真实产线脱敏数据集，面向研究生与工程师提供项目制实训。魔法向量提供算力与工程导师，高校侧提供算法研究与人才输送。",
  },
  {
    id: "news-3",
    title: "2026 春季客户开放日圆满举办",
    date: "2026-04-20",
    category: "公司活动",
    summary: "80 余位企业信息化负责人参观演示中心，体验 AI 质检与智能客服场景。",
    content:
      "开放日设置制造、零售、金融三条参观路线，现场演示从数据采集、模型训练到业务系统对接的完整流程。多位客户信息化负责人在交流环节分享了数字化转型痛点与合作期望。",
  },
  {
    id: "news-4",
    title: "魔法向量通过 ISO 27001 信息安全管理体系认证",
    date: "2026-03-08",
    category: "资质荣誉",
    summary: "标志着公司在数据安全与隐私保护方面达到国际通行标准。",
    content:
      "认证覆盖研发、交付与运维全流程，进一步满足金融、能源等行业客户对供应商安全合规的准入要求。",
  },
];

export const CORPORATE_STATS = [
  { label: "成立年份", value: CORPORATE_COMPANY.founded },
  { label: "服务客户", value: CORPORATE_COMPANY.clients },
  { label: "落地项目", value: CORPORATE_COMPANY.projects },
  { label: "团队成员", value: CORPORATE_COMPANY.employees },
];

export const CORPORATE_VALUES = [
  {
    title: "行业深耕",
    desc: "拒绝通用套壳，每个项目配备行业顾问与算法工程师双负责人。",
  },
  {
    title: "可交付结果",
    desc: "以业务 KPI 为验收标准，提供从 PoC 到规模化复制的完整路径。",
  },
  {
    title: "安全合规",
    desc: "支持私有化部署、国密算法与分级权限，满足监管与内控要求。",
  },
  {
    title: "持续进化",
    desc: "模型与规则随业务反馈迭代，提供 7×24 运维与效果复盘服务。",
  },
];

export const CORPORATE_TIMELINE = [
  { year: "2026", event: "公司在上海成立，首批团队聚焦工业视觉质检。" },
  { year: "2026", event: "发布 TradAI 行业大模型套件，启动制造、零售、金融场景试点。" },
];
